import React from "react";
import { CircularProgress } from "@mui/material";
import useStyles from "@helpers/theme/useStyles";
import BaseButton from "../BaseButton";

export const Button = ({
  children,
  onClick,
  disabled = false,
  size = "middle",
  color = "orange",
  type = "button",
  className = "",
  to = "/",
  isLoading = false,
}) => {
  const style = useStyles();

  return (
    <BaseButton
      as={type === "link" ? "link" : "button"}
      to={to}
      onClick={onClick}
      disabled={disabled || isLoading}
      className={`btn btn--${size} btn--${color} ${className}`}
      type={type}
    >
      {isLoading && type !== "link" && (
        <CircularProgress
          size={24}
          thickness={3.6}
          sx={{
            color: style.main,
            mr: "12px",
          }}
        />
      )}
      {children}
    </BaseButton>
  );
};
